import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { animateScroll } from 'react-scroll';
import {
  Button,
  Grid,
  Typography,
  makeStyles,
  Box,
} from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import { statuses } from 'constants/booking';
import CottageInfo from './CottageInfo';
import Timeline from './Timeline';
import Info from './Info';
import Status from './Status';

const styles = makeStyles((theme) => ({
  scrollButton: {
    marginTop: theme.spacing(2),
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
  status: {
    paddingTop: '10px',
    paddingBottom: '10px',
    textTransform: 'uppercase',
  },
}));

const BookingInfo = (props) => {
  const { booking, isHost, cottage } = props;
  const classes = styles();

  if (!booking) {
    return null;
  }

  return (
    <Box p={1}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Box display="none" displayPrint="block" textAlign="right">
            <img
              src="data:image/png;base64,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"
              className={classes.logo}
              alt="Stugknuten.com"
              style={{ width: 100, height: 33 }}
            />
          </Box>
          <Grid item xs={12} container alignItems="center">
            <Grid item xs={12} sm={8}>
              <Typography variant="h5">
                <FormattedMessage id="Booking" defaultMessage="Booking" /> #{booking.id}
              </Typography>
              <Typography>
                {cottage.title_sv}
              </Typography>
            </Grid>
            <Grid item xs={12} sm={4}>
              <Status booking={booking} />
            </Grid>
          </Grid>
          <Box textAlign="center" mt={2}>
            {
              !isHost && booking.status === statuses.PENDING && (
                <div className={classes.scrollButton}>
                  <Button
                    color="primary"
                    variant="contained"
                    onClick={animateScroll.scrollToBottom}
                  >
                    <FormattedMessage
                      id="Accept"
                      defaultMessage="Accept"
                    />
                  </Button>
                </div>
              )
            }
          </Box>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Info {...props} />
        </Grid>
        <Grid item xs={12} sm={6}>
          <CottageInfo id={cottage.id} cottagePic={cottage.cottagePic} />
          <Timeline booking={booking} />
        </Grid>
        <Grid item xs={12}>
          {
            !isHost && booking.status === statuses.PAID && (
              <Alert severity="info" elevation={3}>
                <FormattedMessage
                  id="bookingForm.guestContactHost"
                  defaultMessage="If any problems arise, please contact the host directly
                    for the problem to be solved as quickly as possible.
                    Also, please contact us via e-mail at {email} to inform us about
                    the problem, at the latest upon your departure day. In this way we can ensure
                    that the problem is solved before your payment to the host is completed."
                  values={{
                    email: (
                      <a
                        style={{ color: 'inherit' }}
                        href="mailto:info@stugknuten.com"
                      >
                        info@stugknuten.com
                      </a>
                    ),
                  }}
                />
              </Alert>
            )
          }
        </Grid>
      </Grid>
    </Box>
  );
};

BookingInfo.propTypes = {
  isHost: PropTypes.bool,
  booking: PropTypes.shape({
    id: PropTypes.number,
    Guest: PropTypes.shape({}).isRequired,
    Host: PropTypes.shape({}).isRequired,
    additional_information: PropTypes.string,
    booking_expiration_date: PropTypes.string,
    cancellationPolicy: PropTypes.shape({}),
    check_in: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]).isRequired,
    check_out: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]).isRequired,
    cleaning_policy: PropTypes.string.isRequired,
    intl: PropTypes.shape({
      formatMessage: PropTypes.func.isRequired,
    }),
    isHost: PropTypes.bool,
    number_of_guests: PropTypes.number.isRequired,
    status: PropTypes.oneOf(Object.values(statuses)),
    total_price: PropTypes.number.isRequired,
  }),
  cottage: PropTypes.shape({
    title_sv: PropTypes.string.isRequired,
    cottagePic: PropTypes.string,
    id: PropTypes.number.isRequired,
  }).isRequired,
  cancellationPolicy: PropTypes.shape({}),
};

export default BookingInfo;
